"use client";
export default function PublicError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="public-container public-page">
      <div className="public-empty" role="alert">
        <h1>Bilgiler şu anda yüklenemiyor.</h1>
        <p>Lütfen kısa süre sonra tekrar deneyin.</p>
        {error.digest ? <p>Hata referansı: {error.digest}</p> : null}
        <button className="public-button" type="button" onClick={reset}>
          Yeniden dene
        </button>
      </div>
    </div>
  );
}
